import styled from "@emotion/styled";

export const Truncate = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Flex = styled.div<{
  gap?: number;
  direction?: "row" | "column";
  justifyContent?: "center" | "flex-end" | "flex-start";
}>`
  display: flex;
  align-items: center;
  gap: ${p => (p.gap !== undefined ? `${p.gap}px` : undefined)};
  flex-direction: ${p => p.direction};
  justify-content: ${p => p.justifyContent};
`;

export const HSpace = styled.div<{ width?: number }>`
  width: ${p => (p.width ? `${p.width}px` : "5px")};
`;

export const VSpace = styled.div<{ height?: number }>`
  height: ${p => (p.height ? `${p.height}px` : "10px")};
`;
